export const getTextLength = (text: string): number => text.length;
